import { render, staticRenderFns } from "./PoliticaPage.vue?vue&type=template&id=ba63e204&scoped=true"
import script from "./PoliticaPage.vue?vue&type=script&lang=js"
export * from "./PoliticaPage.vue?vue&type=script&lang=js"
import style0 from "./PoliticaPage.vue?vue&type=style&index=0&id=ba63e204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba63e204",
  null
  
)

export default component.exports